/**
 * Lead Formatters for Rate Review Module
 * @module RateReviewLeadFormatters
 */

import { RATE_REVIEW_CONSTANTS } from "../constants/rateReviewConstants";

/**
 * Maps lead data to form values for the update modal
 * @param {Object} lead - Lead object from API
 * @returns {Object} Form values object with normalized field names
 */
export const mapLeadToFormValues = (lead) => {
  const getCountryValue = () => {
    const countryValue = Array.isArray(lead.Country_of_Formation)
      ? lead.Country_of_Formation[0] || ""
      : lead.Country_of_Formation || lead.country || "";
    
    return (countryValue === "USA" || countryValue === "Canada") 
      ? countryValue 
      : RATE_REVIEW_CONSTANTS.DEFAULT_COUNTRY;
  };

  return {
    First_Name: lead.First_Name || "",
    Last_Name: lead.Last_Name || "",
    Email: lead.Email || lead.email || "",
    Phone: lead.Phone || lead.phone || "",
    Company: lead.Company || lead.businessName || "",
    Gateway_ID: lead.Gateway_ID || lead.gatewayId || "",
    Sales_Agent: lead.Sales_Agent || lead.salesRep || "",
    Sales_Agent_Email: lead.Sales_Agent_Email || lead.salesRepEmail || "",
    Country_of_Formation: getCountryValue(),
    Lead_Status: lead.Lead_Status || lead.status || RATE_REVIEW_CONSTANTS.DEFAULT_LEAD_STATUS,
    Savings: lead.Savings ?? lead.savings ?? "",
    Notes1: lead.Notes1 || "",
  };
};

